<template>
  <section class="sheet-detail-empty">
    <EmptyStatesStopwatch />
    <h2 class="empty-title">Nog geen geregistreerde uren</h2>
    <p> Klik op '+' om je gewerkte uren te registreren. </p>
  </section>
</template>
<script lang="ts" setup>
import EmptyStatesStopwatch from '@app/icons/EmptyStatesStopwatch.vue';

</script>
<style lang="scss">
.sheet-detail-empty {
  margin-top: 24px;
  justify-content: space-around;
  align-items: center;
  padding: 12px;
  display:flex;
  flex-direction: column;
  font-size: 14px;
  color: var(--pidz-grey-dark);

  .pidz-icon {
    height: 60px;

  }

  .empty-title {
    color: var(--pidz-grey-dark);
    text-transform: initial;
    font-weight: 700;
    font-size: 14px;
    margin: 12px 0 0;
    padding: 0;
  }
}
</style>
